import request from '@/utils/request';
//会员列表
export function getMemberList(param) {
  return request('/decision/model', {
    method: 'GET',
    params: param,
  });
}

//新增会员列表
export function addMember(values) {
  return request('/decision/model', {
    method: 'POST',
    data: values,
  });
}

//编辑会员列表
export function editMember(modelId, values) {
  return request(`/decision/model/${modelId}`, {
    method: 'PUT',
    data: values,
  });
}

// 删除接口
export function deleteModel(modelId) {
  return request(`/decision/model/${modelId}`, {
    method: 'DELETE',
  });
}

// 导出接口
export function exportModel(modelId) {
  return request(`/decision/model/export/${modelId}`, {
    method: 'GET',
    responseType: 'arraybuffer',
  });
}

// 操作记录页面获取接口
export function getLog(modelId) {
  return request(`/decision/model/operatorLog/${modelId}`, {
    method: 'GET',
  });
}

// 模型名称页面获取接口
export function getModalNameTable(param) {
  return request('/decision/model/model-field', {
    method: 'GET',
    params: param,
  });
}

// 决策图管理页面获取接口
export function saveGraphTable(values) {
  return request('/decision/diagram/node-input-item', {
    method: 'POST',
    data: values,
  });
}
// 获取每个节点的下拉选择
export function getItemNodeSelect(param) {
  return request('/decision/diagram/construct/node-previous', {
    method: 'GET',
    params: param,
  });
}
// 决策图管理页面获取table接口
export function getGraphTable(param) {
  return request('/decision/diagram', {
    method: 'GET',
    params: param,
  });
}

// 决策图管理页面新增流程
export function addDiagram(values) {
  return request('/decision/diagram', {
    method: 'POST',
    data: values,
  });
}

// 决策图管理页面编辑流程
export function editDiagram(diagramId, values) {
  return request(`/decision/diagram/${diagramId}`, {
    method: 'PUT',
    data: values,
  });
}

// 删除接口
export function deleteDiagram(modelId, params) {
  return request(`/decision/diagram/${modelId}`, {
    method: 'DELETE',
    params: params,
  });
}

// 决策图管理操作日志页面获取接口
export function getDiagramLog(modelId) {
  return request(`/decision/diagram/log/${modelId}`, {
    method: 'GET',
  });
}

// 决策图管理流程charts图
export function getDecisionGraphMap(modelId) {
  return request(`/decision/diagram/construct/${modelId}`, {
    method: 'GET',
  });
}

// 决策图管理流程获取所有规则包/模型包数据
export function getDiagramNodeBlock() {
  return request('/decision/diagram/construct/node-block', {
    method: 'GET',
  });
}

// 入参配置列表
export function getNodeInputItemTable(params) {
  return request('/decision/diagram/node-input-item', {
    method: 'GET',
    params: params,
  });
}

// 入参配置log日志
export function inputItemConfigLog(nodeId) {
  return request(`/decision/diagram/node-input-item/${nodeId.nodeId}/log`, {
    method: 'GET',
  });
}

// 决策图管理试运行
export function checkDiagram(diagramId) {
  return request(`/decision/diagram/construct/check/${diagramId}`, {
    method: 'GET',
  });
}

// 决策图管理保存
export function saveDiagram(diagramId, data) {
  return request(`/decision/diagram/construct/${diagramId}`, {
    method: 'PUT',
    data,
  });
}

// 获取所有配置过的规则包/模型包数据
export function queryNodeBlock() {
  return request('/decision/diagram/construct/node-block', {
    method: 'get',
    data: null,
  });
}

/**
 * combine relation 组合关系
 */
export const queryCombineRelation = (params) => {
  // 查询组合关系
  return request('/decision/rule/combine-relation', {
    method: 'GET',
    params: params,
  });
};

// 查询版本list
export const getVersion = (params) => {
  return request('/decision/diagram/version', {
    method: 'GET',
    params: params,
  });
};

// 切换版本
export const changeVersion = (values) => {
  return request('/decision/diagram/version', {
    method: 'POST',
    data: values,
  });
};
